import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectLoggedInUserId } from "../../../../Store/features/user/userSlice";
import { FaLinkedin } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import avatar4 from "../../../../Images/avatars/image-1.png";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { environment } from "../../../../environments/environment";
import axios from "axios";
import "./About.scss";

const About = ({ community, setShowSignupModal, handleJoinCommunity }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const loggedInUserId = useSelector(selectLoggedInUserId);

	const [joiningCommunityId, setJoiningCommunityId] = useState(null);
	const [showPaymentModal, setShowPaymentModal] = useState(false);
	const [selectedCommunity, setSelectedCommunity] = useState(null);

	const handleAdminClick = (username) => {
		navigate(`/user/${username}`);
	};

	const admin = community?.adminId;

		const defaultBanner =
			"https://res.cloudinary.com/drjt9guif/image/upload/v1741249287/TheCapitalHub/posts/images/bz1xznrsq7grf4qrw8qa.webp";

	const createMarkup = (content) => {
		return { __html: content };
	};

	return (
		<div className="about-container">
			<ToastContainer />
			<div className="community-banner">
				<img
					src={community?.banner_image || defaultBanner}
					alt="Community Banner"
				/>
			</div>

			<div className="community-info">
				<div className="community-header">
					<img
						src={community?.image}
						alt={community?.name}
						className="community-logo"
					/>
					<h1>{community?.name}</h1>

					{/* Join Button */}
					{!community?.members?.some(
						(member) => member?.member?._id === loggedInUserId
					) &&
						community?.isOpen &&
						community?.adminId._id !== loggedInUserId && (
							<button
								className="join-button"
								disabled={joiningCommunityId === community._id}
								onClick={() => handleJoinCommunity(community)}
							>
								{!loggedInUserId
									? "Join the Community"
									: joiningCommunityId
									? "Joining..."
									: "Join the Community"}
							</button>
						)}
				</div>

				<div className="content-section">
					<div className="description-section">
						<h2 className="community-heading">About Community</h2>
						<div
							className="quill-content"
							dangerouslySetInnerHTML={createMarkup(community?.description)}
						/>
						<div
							className="quill-content"
							dangerouslySetInnerHTML={createMarkup(community?.about)}
						/>
					</div>

					{/* Join Button */}
					<div className="btn-center">
						{!community?.members?.some(
							(member) => member?.member?._id === loggedInUserId
						) &&
							community?.isOpen &&
							community?.adminId._id !== loggedInUserId && (
								<button
									className="join-button"
									disabled={joiningCommunityId === community._id}
									onClick={(e) => handleJoinCommunity(e, community)}
								>
									{!loggedInUserId
										? "Join Community"
										: joiningCommunityId
										? "Joining..."
										: "Join Community"}
								</button>
							)}
					</div>

					<div className="admin-section">
						<h2 className="community-heading">Community Admin</h2>
						{admin && (
							<div
								className="admin-card"
								onClick={() => handleAdminClick(admin.userName)}
							>
								<img
									src={admin.profilePicture || avatar4}
									alt={`${admin.firstName} ${admin.lastName}`}
								/>
								<div className="admin-info">
									<h3 style={{ display: "flex", alignItems: "center" }}>
										{admin.firstName} {admin.lastName}
										{admin.linkedin && (
											<a
												href={admin.linkedin}
												target="_blank"
												rel="noopener noreferrer"
												className="linkedin-link"
												style={{ marginLeft: "8px" }}
												onClick={(e) => e.stopPropagation()}
											>
												<FaLinkedin />
											</a>
										)}
									</h3>

									<p className="company">
										{admin.startUp?.company ||
											admin.investor?.companyName ||
											"Company not specified"}
									</p>
									<p className="designation">
										{admin.designation || "Designation not specified"}
									</p>
									<p className="location">
										{admin.location || "Location not specified"}
									</p>
									<p className="bio">{admin.bio || "No bio available"}</p>
								</div>
							</div>
						)}
					</div>

					<div className="terms-section">
						<h2 className="community-heading">Terms and Conditions</h2>
						{Array.isArray(community?.terms_and_conditions) &&
						community.terms_and_conditions.length > 0 ? (
							<ul>
								{community.terms_and_conditions.map((term, index) => (
									<li key={index}>{term}</li>
								))}
							</ul>
						) : (
							<p>No terms and conditions available</p>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default About;
